import { Injectable } from '@angular/core';
import { initFlowbite } from 'flowbite';

@Injectable({
  providedIn: 'root',
})
export class FlowbiteService {
  private initialized = false;

  initializeFlowbite(): void {
    this.initialized = true;
    initFlowbite();
  }

  reinitializeFlowbite(): void {
    if (this.initialized) {
      initFlowbite();
    }
  }
}
